/* Mobiele koopbalk. Doorgeefluik naar het echte formulier, geen eigen toestand.

   Drie dingen:
   1. Verschijnt zodra de echte koopknop uit beeld is, met een IntersectionObserver.
      Niet met een scrollpositie, want de hoogte van de pagina verschilt per product.
   2. Spiegelt prijs en uitverkocht-status uit de echte knop, met een MutationObserver.
      Dawn vervangt bij een variantwissel het hele blok, dus een eenmalige uitlezing loopt
      binnen een klik uit de pas.
   3. De knop klikt de echte knop aan. Nooit zelf een fetch naar /cart/add doen: dan mis je
      Dawn's foutafhandeling en de wagenlade.
*/
(() => {
  const balk = document.querySelector('[data-fb-atc]');
  if (!balk) return;

  // Verhuizen naar body, en dat is geen netheid maar noodzaak. De balk wordt als block
  // in de productsectie gerenderd, en .product__info-wrapper draagt Dawn's scroll-trigger
  // met transform: matrix(1,0,0,1,0,0). Een identiteitstransform, maar ELKE transform
  // maakt een nieuw referentiekader voor position: fixed. De balk kreeg daardoor hoogte 0
  // en stond op top 0 in plaats van onderaan het scherm. Zelfde animatieklasse als valkuil 10.
  // Bijvangst: hiermee staat de balk ook buiten het bereik van de MutationObserver hieronder.
  document.body.appendChild(balk);

  const prijsUit = balk.querySelector('[data-fb-atc-price]');
  const notitie = balk.querySelector('[data-fb-atc-note]');
  const knop = balk.querySelector('[data-fb-atc-button]');

  const echteKnop = () => document.querySelector('.product-form__submit');
  const echtePrijs = () => document.querySelector('.price__container .price-item--regular, .price__container .price-item--sale');

  // Alleen schrijven als er echt iets verandert. Zonder deze poort loopt de pagina vast,
  // en dat is geen theorie: het gebeurde. De balk staat binnen product-info, dus elke
  // schrijfactie is zelf weer een mutatie die de observer opnieuw afvuurt. Twee browsers
  // bevroren erop.
  function zet(el, waarde) {
    if (el.textContent !== waarde) el.textContent = waarde;
  }

  function spiegel() {
    const k = echteKnop();
    if (!k) return;
    const uitverkocht = k.hasAttribute('disabled');
    if (knop.disabled !== uitverkocht) knop.disabled = uitverkocht;
    zet(knop, k.textContent.replace(/\s+/g, ' ').trim());
    const p = echtePrijs();
    if (p) zet(prijsUit, p.textContent.replace(/\s+/g, ' ').trim());
  }

  function toon(aan) {
    if (aan) balk.removeAttribute('hidden');
    else balk.setAttribute('hidden', '');
  }

  // 1. verschijnen
  //
  // GEEN IntersectionObserver. Die klinkt hier logisch maar heeft een blinde vlek: de knop
  // begint ONDER de vouw (niet zichtbaar) en gaat bij een veeg naar beneden in één keer
  // naar BOVEN de vouw (ook niet zichtbaar). isIntersecting verandert dan niet van waarde,
  // dus de callback vuurt nooit en de balk blijft weg. Stapsgewijs scrollen verbergt dat,
  // want dan is de knop tussendoor wel even zichtbaar. Drie van de drie keer mis met een
  // sprong naar de onderkant, en een gebruiker die vlug naar beneden veegt doet precies dat.
  //
  // Een scrollluisteraar met requestAnimationFrame heeft die blinde vlek niet: hij kijkt
  // naar de werkelijke positie in plaats van naar een overgang.
  let gepland = false;
  function kijk() {
    gepland = false;
    const k = echteKnop();
    if (!k) return;
    toon(k.getBoundingClientRect().bottom < 0);
  }
  function plan() {
    if (gepland) return;
    gepland = true;
    requestAnimationFrame(kijk);
  }
  addEventListener('scroll', plan, { passive: true });
  addEventListener('resize', plan, { passive: true });
  kijk();

  // 2. spiegelen
  // Kijk alleen naar de blokken die er echt toe doen, niet naar heel product-info. Dat
  // scheelt werk en houdt de balk zelf buiten het bereik van de observer.
  spiegel();
  const spiegelObserver = new MutationObserver(spiegel);
  const volg = (el) => el && spiegelObserver.observe(el, { childList: true, subtree: true, attributes: true });
  volg(document.querySelector('.price'));
  volg(document.querySelector('.product-form__buttons'));

  // 3. doorgeven
  knop.addEventListener('click', () => {
    const echte = echteKnop();
    if (!echte || echte.hasAttribute('disabled')) return;
    echte.click();
  });

  // de wagenlade mag er niet achter verdwijnen
  document.addEventListener('cart:refresh', () => toon(false));
  document.addEventListener('cart-drawer:open', () => toon(false));

  // De aanmoedigingsregel komt uit Liquid, zie de noot in fb-sticky-atc.liquid.
  // Hier niets meer van de pagina schrapen: het staffelpaneel staat niet meer op de
  // productpagina en dan viel de regel stilzwijgend weg.
})();
